import React, { JSX, useMemo } from "react";
import GlobalStyle from "../../../styles/GlobalStyle";
import {
  scaleHorizontal,
  FontSizes,
  scaleModerate,
  scaleVertical,
} from "../../../styles/responsive";
import { V2ReportStyle } from "../../../styles/V2ReportStyle";
import { ReortLabels } from "../../../utils/helpers/newReportHelper";
import { DentalIconSvg } from "../../../utils/Svgs";
import RenderCheckList from "../../UI/RenderCheckList";
import SectionHeading from "../../UI/SectionHeading";
import StatusLabel from "../../UI/StatusLabel";
import { PALLETTE } from "../../../utils/theme";

const ExaminationOfGingiva = ({
  topLefticon,
  title,
  suggestionText,
  showHeading = true,
  data,
  label,
}: {
  topLefticon?: JSX.Element;
  title: string;
  suggestionText: string;
  showHeading?: boolean;
  data: Record<string, any>;
  label: any;
}) => {
  const ClinicalExaminationData = useMemo(
    () =>
      Object.entries(data || {}).map(([key, isChecked]) => ({
        title: ReortLabels[key],
        isChecked,
      })),
    [data],
  );

  const ailmentKeys = useMemo(
    () => Object.keys(data || {}).filter((key) => data[key]),
    [data],
  );

  return (
    <div>
      {showHeading && (
        <SectionHeading
          icon={<DentalIconSvg />}
          title="Examination of Gingiva"
        />
      )}
      <div style={V2ReportStyle.card}>
        <div
          style={{
            ...V2ReportStyle.flexRowCenter,
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          <div
            style={{
              ...V2ReportStyle.flexRowCenter,
              gap: scaleHorizontal(2),
              display: "flex",
            }}
          >
            {topLefticon}
            <span
              style={{
                ...GlobalStyle.blackBoldText,
                fontSize: "2.2rem",
              }}
            >
              {title}
            </span>
            {/* {label === "Need Attention" && (
              <AlertWave
                ailmentKeys={ailmentKeys}
                label={label}
                title={title}
                showHeading={true}
              />
            )} */}
          </div>
          <StatusLabel lable={label} />
        </div>

        <div
          style={{
            ...V2ReportStyle.card,
            backgroundColor: PALLETTE.background,
            padding: scaleModerate(12),
            flex: 1,
            gap: scaleHorizontal(20),
            display: "flex",
            flexDirection: "row",
            marginTop: scaleVertical(12),
            justifyContent: "space-between",
          }}
        >
          {ClinicalExaminationData?.map((item, index) => {
            return <RenderCheckList width={"80%"} key={index} {...item} />;
          })}
        </div>

        <div
          style={{
            paddingTop: scaleVertical(16),
            paddingBottom: scaleVertical(16),
          }}
        >
          <span
            style={{
              ...GlobalStyle.blackMediumText,
              fontSize: "2.2rem",
            }}
          >
            {suggestionText}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExaminationOfGingiva;
